import { twMerge as twm } from 'tailwind-merge'

import { Icon } from '../Icon'
import Label from '../app/design/Label'
import Paragraph from '../app/design/Paragraph'

type Props = {
    items: {
        title: string
        subtitle?: string
        status: 'checked' | 'empty'
    }[]
    className?: string
}

export const RecordStatusChecklist = ({ items, className }: Props) => {
    return (
        <div className={twm('flex flex-col items-stretch justify-start gap-y-2', className)}>
            {items.map((item, itemIndex) => (
                <div key={item.title} className="flex items-start justify-start gap-x-4">
                    <div className="flex flex-col items-center justify-start gap-y-2">
                        <div
                            className={twm(
                                'flex size-6 items-center justify-center rounded-full border-2',
                                item.status === 'checked'
                                    ? 'border-primary-700'
                                    : 'border-gray-300',
                                item.status === 'checked' && 'bg-primary-700'
                            )}
                        >
                            {item.status === 'checked' && (
                                <Icon icon="checkmark.large" className="size-4 text-white" />
                            )}
                        </div>

                        {itemIndex !== items.length - 1 && (
                            <div
                                className="w-0.5 bg-gray-300"
                                style={{ height: item.subtitle !== undefined ? 36 : 16 }}
                            />
                        )}
                    </div>

                    <div className="flex flex-col items-start justify-start gap-y-1">
                        <Label size="md" className="font-bold">
                            {item.title}
                        </Label>
                        {item.subtitle && (
                            <Paragraph size="sm" className="font-normal text-gray-600">
                                {item.subtitle}
                            </Paragraph>
                        )}
                    </div>
                </div>
            ))}
        </div>
    )
}
